import moment from "moment";

export interface IFinOpsCogs {
    category: string;
    type: string;
    lastYearCost: number;
    lastYearQuantity?: number;
    unit: string;
}

export interface IFinOpsBudget extends IFinOpsCogs {
    id: number;
    fiscalYear: string;
    serviceId: string;
    increaseRate: number;
    quantityBudget?: number;
    costBudget: number;
    submitter?: string;
    version?: moment.Moment;
    approver?: string;
    approved?: number;
    approvedTime?: moment.Moment;
    justification?: string;
    comment?: string;
    isServiceAffectedByCopilot?: number;
    children?: IFinOpsBudget[];
}

export const BudgetDisplayNames : Record<keyof IFinOpsBudget, string> = {
    id: 'ID',
    fiscalYear: 'Fiscal Year', 
    category: 'Category',
    type: 'Type',
    unit: 'Unit',
    isServiceAffectedByCopilot: 'Is Service Affected By Copilot',
    increaseRate: 'Increase Rate',
    costBudget: 'Cost Budget',
    quantityBudget: 'Quantity Budget',
    submitter: 'Submitter',
    justification: 'Justification',
    comment: 'Comment',
    serviceId: 'Service',
    version: 'Version',
    approver: 'Approver',
    approved: 'Approved',
    approvedTime: 'Approved Time',
    lastYearCost: 'Last Year Cost',
    lastYearQuantity: 'Last Year Quantity',
    children: 'Children',
};

export interface IFinOpsBudgetFilters {
    fiscalYear?: string;
    serviceId?: string;
    serviceGM?: string;
    category?: string;
    type?: string;
    submitter?: string;
}

export enum FinOpsReviewStatus {
    Pending,
    Denied,
    Approved
}

export enum FinOpsBudgetFiltersEnum {
    FiscalYear = "FiscalYear",
    ServiceId = "ServiceId",
    Category = "Category",
    Type = "Type",
    Submitter = "Submitter"
}

export interface IFinOpsMonthlyBudgetAllocation {
    month?: string;
    serviceId?: string;
    serviceName?: string;
    category?: string;
    type?: string;
    isAIService?: number;
    budget?: number;
    cost?: number;
}

export interface IFinOpsBudgetAllocationCombined {
    gem?: string;
    month?: string;
    serviceId?: string;
    serviceName?: string;
    category?: string;
    type?: string;
    isAIService?: number;
    budget?: number;
    cost?: number;
}

export interface IFinOpsBudgetAllocationTableRow {
    month: string;
    budget: number;
    cost: number;
}

export interface IFinOpsServiceGEMMapping {
    serviceId?: string;
    serviceName?: string;
    primaryDevOwner?: string;
    primaryPMOwner?: string;
    gemAlias?: string;
    gemFullName?: string;
}

export const BudgetTrackingMetricsName: Record<string, string> = {
    'actualCost': 'Actual Cost',
    'forecastCost': 'Forecast Cost',
    'budget': 'Budget'
}

export const BudgetTrackingMetrics = [
    "actualCost",
    "forecastCost"
];

export interface IFinOpsServiceDetailTableRow {
    month?: string;
    cost?: number;
    budgetTarget?: number;
}

export enum FinOpsTrackingViewTypeEnum {
    LT,
    GEM,
    Service,
    Category,
}

export const FinOpsCostKeys: (TypedKeyOf<IFinOpsBudgetAllocationTableRow, number>)[] = ['cost', 'budget'];

export const FinOpsCostTableKeys: Record<FinOpsTrackingViewTypeEnum, (keyof Partial<IFinOpsBudgetAllocationTableRow>)[]> = {
    [FinOpsTrackingViewTypeEnum.LT]: ['month', 'cost', 'budget'],
    [FinOpsTrackingViewTypeEnum.GEM]: ['month', 'cost', 'budget'],
    [FinOpsTrackingViewTypeEnum.Service]: ['month', 'cost', 'budget'],
    [FinOpsTrackingViewTypeEnum.Category]: ['month', 'cost', 'budget'],
};

export const FinOpsServiceDetailTableDisplayNames: Record<keyof IFinOpsBudgetAllocationTableRow, string> = {
    month: 'Month',
    cost: 'Cost',
    budget: 'Budget Target',   
}

export type MonthKey = 
  | 'month1' | 'month2' | 'month3' | 'month4' | 'month5' | 'month6'
  | 'month7' | 'month8' | 'month9' | 'month10' | 'month11' | 'month12';

export type IFinOpsMonthlyBudgetAllocationRecord = {
  version: Date;
  fiscalYear: string;
  serviceId: string;
  category: string;
  type: string;
  submitter: string;
} & {
  [key in MonthKey]: number;
};

export interface IFinOpsBaseline {
    month?: string;
    serviceId?: string;
    serviceName?: string;
    category?: string;
    type?: string;
    isAIService?: number;
    budget?: number;
    cost?: number;
    gem?: string;
}